import Image from 'next/image';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { CarouselIndicators, ZoomControls } from '@/entities/image-carousel';
import { blurDataURL, classNames } from '@/shared/lib';
import { useImageErrors } from '@/shared/lib/hooks';
import { YandexInImageAd } from '@/shared/ui/ads';

import 'swiper/css';

interface Props {
  pictures: string[];
  toggleFullSize: (() => void) | null;
  currentImageIndex: number;
  handleImageCurrentIndex: (index: number) => void;
}

export default function ImageSlider({
  pictures,
  toggleFullSize,
  currentImageIndex,
  handleImageCurrentIndex
}: Props) {
  const { imageErrors, handleImageError } = useImageErrors(pictures);

  return (
    <>
      {toggleFullSize && <ZoomControls toggleFullSize={toggleFullSize} />}
      <YandexInImageAd blockId="R-A-11959228-5" />

      <Swiper
        onSlideChange={(swiper) => handleImageCurrentIndex(swiper.realIndex)}
        initialSlide={currentImageIndex}
        className="h-[380px] w-full"
        loop={true}
      >
        {pictures.map((picture, index) => {
          const isBroken = imageErrors[index];
          const isFirst = index === 0;
          const isActive = index === currentImageIndex;

          return (
            <SwiperSlide key={index} className="flex h-full w-full">
              <Image
                src={isBroken ? '/broken-image.svg' : picture}
                alt={`carousel-image-mobile-${index}`}
                fill
                placeholder="blur"
                blurDataURL={blurDataURL}
                loading={isFirst ? 'eager' : 'lazy'}
                priority={isFirst}
                fetchPriority={isActive ? 'high' : 'low'}
                sizes="(max-width: 768px) 100vw, 600px"
                className={classNames(
                  'h-[380px] rounded-2xl object-cover',
                  isBroken ? 'bg-slate-400' : ''
                )}
                decoding="async"
                onError={() => handleImageError(index)}
                onClick={toggleFullSize ? toggleFullSize : undefined}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>

      <CarouselIndicators currentIndex={currentImageIndex} length={pictures.length} />
    </>
  );
}
